import { render } from "./GolfExtraShowComponent.vue?vue&type=template&id=167169b6"
import script from "./GolfExtraShowComponent.vue?vue&type=script&lang=js"
export * from "./GolfExtraShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__